<template>
  <div>
    <thermometer-file :tableData="tableData" :tablePage="page">
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </thermometer-file>
  </div>
</template>
<script>
import ThermometerFile from './components/thermometerFileTemplate'
import BaseTable from '@/mixins/base-table'
export default {
  components: {
    ThermometerFile,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      formData: {
        keyword: '',
        importTemplateType: 'thermometer',
        importTemplateStatusList: ['Y'],
      },
    }
  },
  mounted() {
    this.getData(this.formData)
  },
  methods: {
    getData(formData) {
      this.$api
        .sysOrderTemplateListApi({
          ...formData,
          ...this.page,
        })
        .then((res) => {
          this.setData(res)
        })
    },

    handlePaginationChange(val) {
      this.page = {
        curPage: val.current,
        pageSize: val.size,
        pageTotal: val.total,
      }
      this.getData(this.formData)
    },
  },
}
</script>
